
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "branchAdd",
    title: "Branch Add",
    icon: "ri-home-gear-line",
    path: "/branch/add",
    activePaths: ["/branch/add"],
    visibility: (client) => client?.is_main_branch === "1",
  },
  {
    id: "branchList",
    title: "Branch List",
    icon: "ri-building-line",
    path: "/all/branch/list",
    activePaths: ["/all/branch/list"],
    visibility: (client) => client?.is_main_branch === "1",
  },
  {
    id: "studentTransfer",
    title: "Student Transfer",
    icon: "ri-arrow-left-right-line",
    path: "/student/transfer/branch",
    activePaths: ["/student/transfer/branch"],
  },
  {
    id: "studentTransferList",
    title: "Student Transfer List",
    icon: "ri-file-list-3-line",
    path: "/student/transfer/list",
    activePaths: ["/student/transfer/list"],
  },
];

export default function TransferBranchLayout({ children }) {
  return
  return (
    <div className="mt-2">
      <ModuleHeader tabs={tabs} />
      {children}
    </div>
  );
}
